import { useEffect } from 'react';
import amplitudeClient, { initAmplitude, setUser, setUserProperties, track } from '../lib/analytics/amplitudeClient';

export const useAnalytics = () => {
  useEffect(() => {
    initAmplitude();
  }, []);

  return {
    initAmplitude,
    setUser,
    setUserProperties,
    track,
  } as const;
};

export default useAnalytics;

